import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatOrderCreatedDate = (dateString) => {
  //dayjs(dateString).format("MMM D, hh:mm A");
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("MMM D, hh:mm A");
};

export const formatYYYY_MM_DD = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("YYYY-MM-DD");
};

export const formatYYYY_MM_DD_HH_MM_A = (dateString) => {
  
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY-MM-DD hh:mm A");
};

export const formatHH_MM_SS = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("hh:mm A");
};

export const formatPaymentDate = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("MMMM D, YYYY, h:mm A");
};

export const formatChatDate = (dateString) => {
  if (!dateString || isNaN(new Date(dateString))) return "-";

  // Parse the input date and convert to local timezone
  const messageDate = dayjs.utc(dateString).tz(dayjs.tz.guess());
  const now = dayjs();

  // Start of today and yesterday (local time)
  const startOfToday = now.startOf("day");
  const startOfYesterday = now.subtract(1, "day").startOf("day");

  // Check if the date falls within today or yesterday
  if (messageDate.isAfter(startOfToday)) return "Today";
  if (messageDate.isAfter(startOfYesterday)) return "Yesterday";

  // For all other dates, return formatted date
  return messageDate.format("MMMM DD, YYYY");
};


export const formatIndicatorDate = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY/MM/DD hh:mm A");
};